// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__trsUs","footer":"styles_footer__k6B4K","passCodeTooltip":"styles_passCodeTooltip__1yVU2"};